module.exports = "/_next/static/images/51b491b5403f6ff81b4da07d756c8d7d-savings-without-logos-xs-2x.jpg";